import { render, staticRenderFns } from "./accountMangement.vue?vue&type=template&id=3f138dd5&scoped=true&"
import script from "./accountMangement.vue?vue&type=script&lang=js&"
export * from "./accountMangement.vue?vue&type=script&lang=js&"
import style0 from "./accountMangement.vue?vue&type=style&index=0&id=3f138dd5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f138dd5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3f138dd5', component.options)
    } else {
      api.reload('3f138dd5', component.options)
    }
    module.hot.accept("./accountMangement.vue?vue&type=template&id=3f138dd5&scoped=true&", function () {
      api.rerender('3f138dd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/accountMangement.vue"
export default component.exports